import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueLazyload from 'vue-lazyload'
import infiniteScroll from 'vue-infinite-scroll'
import VueCookie from 'vue-cookie'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { getUserInfo } from './api/system.js'
import { getStore } from '/utils/storage'
import VueContentPlaceholders from 'vue-content-placeholders'
Vue.use(VueContentPlaceholders)
Vue.use(ElementUI)
Vue.use(infiniteScroll)
Vue.use(VueCookie)
Vue.use(VueLazyload, {
  // preLoad: 1.3,
  // error: 'dist/error.png',
  loading: '/static/images/load.gif'
  // attempt: 1
})
Vue.config.productionTip = false
router.beforeEach(function (to, from, next) {
  if (getStore('hht-pc-token')) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      if (store.state.userInfo) {
        next()
      } else {
        getUserInfo().then(res => {
          store.commit('RECORD_USERINFO', res)
          next()
        })
        // .catch(() => {
        //   removeStore('hht-pc-token')
        //   next({ path: '/login' })
        // })
      }
    }
  } else {
    next()
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js